
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateService } from 'src/app/services/date/date.service';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'date-selector-modal',
  templateUrl: 'date-selector-modal.component.html',
  styleUrls: ['./date-selector-modal.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: DateSelectorModalComponent
    },
    {
        provide: NG_VALIDATORS, 
        useExisting: forwardRef(() => DateSelectorModalComponent),
        multi: true,
    },
]
})
export class DateSelectorModalComponent implements OnInit {
  local:string = "fr-fr";
  month:string;
  @Input()
  minDate:string;
  @Input()
  maxDate:string;
  @Input()
  dayValues:string;
  @Input()
  title:string;
  day:string;  
  year:string;
  dayName: string;
  dateStrLocal:string;
  showPicker = false;
  onChange = (value) => {};
  onTouched = () => {};
  onValidationChange: any = () => {};
  // @Input()
  // value:string | any ;

  @Input('value')
    set value(value:string|any){
      if(value){
        this._value = value;
        const date = new Date(value);
        this.dateStrLocal = date.toLocaleString(this.local, { weekday: 'short', month: 'short', day: 'numeric' });        
      }
      console.log('set value',value,this.dateStrLocal);
    }
  _value:string;

  touched = false;
  @Input()
  disabled = false;

  @Output() valueChanged = new EventEmitter<string>();


  constructor(dateService:DateService) {

  }

  ngOnInit(){
  }
  itemClicked(){
    this.showPicker = !this.disabled;
  }

  dateChanged(value){
    console.log('dateChanged',value);
    this.writeValue(value);
    this.onChange(value);
    this.onValidationChange();
    this.showPicker = false;
    this.valueChanged.emit(value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  writeValue(value: string| any) {
    // console.log(value);
    const date = new Date(value);
    if(value){
      this.dateStrLocal = date.toLocaleString(this.local, { weekday: 'short', year: '2-digit', month: 'short', day: 'numeric' });
      this._value = value;
    }
  }

  registerOnTouched(onTouched: any) {
      this.onTouched = onTouched;
  }

  markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
  }

  validate(control: AbstractControl): ValidationErrors {
      return null //this._value?null:{invalid:true};
  }

  registerOnValidatorChange?(fn: () => void): void {
      this.onValidationChange = fn;
  }

  inputValidator(): ValidatorFn  {
      return (control:AbstractControl) : ValidationErrors | null => {
          if(!this._value){
              return {label:{value:false}}
          }
          else {
              return null
          }
      };
  }
}
